import { useParams } from "react-router-dom"

export const useRequiredSerialNumber = (): string => {
    const { serial_number } = useParams()

    if (!serial_number) {
        throw new Error("serial number must be provided")
    }

    return serial_number
}
